import "./App.css";
import Component from "./components/Component";
import Navbar from "./components/navbar/Navbar";

function App() {
 return (
  <div className="app">
   <Navbar />
   <Component />
  </div>
 );
}

export default App;
